export default "__VITE_ASSET__kgwI0eWf__"